import { GlobalTrapFocusProvider } from '@/components/common/GlobalTrapFocusContext';
import client from '@/services/graphql/client';
import { stytch } from '@/services/stytch';
import theme from '@/styles/theme';
import { ApolloProvider } from '@apollo/client';
import { ChakraProvider } from '@chakra-ui/react';
import { StytchProvider } from '@stytch/nextjs';
import type { AppProps } from 'next/app';
import './styles.css';
import { ErrorLoggerProvider } from '@/components/ErrorLoggerProvider';

function App({ Component, pageProps }: AppProps) {
    return (
        <>
            <ErrorLoggerProvider>
                <StytchProvider stytch={stytch}>
                    <ApolloProvider client={client}>
                        <ChakraProvider theme={theme}>
                            <GlobalTrapFocusProvider>
                                <Component {...pageProps} />
                            </GlobalTrapFocusProvider>
                        </ChakraProvider>
                    </ApolloProvider>
                </StytchProvider>
            </ErrorLoggerProvider>
        </>
    );
}

export default App;
